// Minimal JSON fetch helper for Vue components. Reads the Rails CSRF token from
// the <meta name="csrf-token"> tag rendered in both the admin and public layouts.

function csrfToken(): string {
  return (
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
  )
}

interface JsonError {
  errors?: string[]
}

async function sendJSON<T>(method: string, url: string, body: unknown): Promise<T> {
  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: JSON.stringify(body),
  })

  const data = (await response.json().catch(() => ({}))) as T & JsonError
  if (!response.ok) {
    throw new Error(data.errors?.join(", ") || `Request failed (${response.status})`)
  }
  return data
}

export function patchJSON<T = unknown>(url: string, body: unknown): Promise<T> {
  return sendJSON<T>("PATCH", url, body)
}

export function postJSON<T = unknown>(url: string, body: unknown): Promise<T> {
  return sendJSON<T>("POST", url, body)
}
